/**
 * Tooling 模块常量定义（自动生成）
 * 
 * ⚠️ 此文件由 api:export-types 命令自动生成
 * ⚠️ 请勿手动编辑！如需修改，请修改后端代码后重新生成
 * 
 * 包含：
 * - 枚举标签映射（中文）
 * - 权限常量定义
 * 
 * 验证规则请查看 validations.ts
 * 
 * @generated 2025-11-01T18:25:57.307139Z
 * @generator api:export-types v1.0.0
 */

import { FixtureSTATUS, GaugeSTATUS, GaugeCalibrationLogTYPE, GaugeCalibrationLogRESULT, MoldSTATUS, ToolSTATUS, ToolLIFETIME } from './enums'

// ==================== 枚举标签映射 ====================

/**
 * Fixture状态 标签映射
 */
export const FIXTURE_STATUS_LABELS = {
  [FixtureSTATUS.NORMAL]: 'NORMAL',
  [FixtureSTATUS.IN_USE]: 'IN_USE',
  [FixtureSTATUS.NEED_MAINTENANCE]: 'NEED_MAINTENANCE',
  [FixtureSTATUS.SCRAPPED]: 'SCRAPPED',
} as const

/**
 * Gauge状态 标签映射
 */
export const GAUGE_STATUS_LABELS = {
  [GaugeSTATUS.NORMAL]: 'NORMAL',
  [GaugeSTATUS.IN_USE]: 'IN_USE',
  [GaugeSTATUS.NEED_CALIBRATION]: 'NEED_CALIBRATION',
  [GaugeSTATUS.EXPIRED]: 'EXPIRED',
  [GaugeSTATUS.DISABLED]: 'DISABLED',
} as const

/**
 * GaugeCalibrationLog类型 标签映射
 */
export const GAUGE_CALIBRATION_LOG_TYPE_LABELS = {
  [GaugeCalibrationLogTYPE.INTERNAL]: 'INTERNAL',
  [GaugeCalibrationLogTYPE.EXTERNAL]: 'EXTERNAL',
} as const

/**
 * GaugeCalibrationLogRESULT 标签映射
 */
export const GAUGE_CALIBRATION_LOG_RESULT_LABELS = {
  [GaugeCalibrationLogRESULT.QUALIFIED]: 'QUALIFIED',
  [GaugeCalibrationLogRESULT.UNQUALIFIED]: 'UNQUALIFIED',
} as const

/**
 * Mold状态 标签映射
 */
export const MOLD_STATUS_LABELS = {
  [MoldSTATUS.NORMAL]: 'NORMAL',
  [MoldSTATUS.IN_USE]: 'IN_USE',
  [MoldSTATUS.NEED_MAINTENANCE]: 'NEED_MAINTENANCE',
  [MoldSTATUS.SCRAPPED]: 'SCRAPPED',
} as const

/**
 * Tool状态 标签映射
 */
export const TOOL_STATUS_LABELS = {
  [ToolSTATUS.NORMAL]: 'NORMAL',
  [ToolSTATUS.IN_USE]: 'IN_USE',
  [ToolSTATUS.NEED_REPLACE]: 'NEED_REPLACE',
  [ToolSTATUS.SCRAPPED]: 'SCRAPPED',
} as const

/**
 * ToolLIFETIME 标签映射
 */
export const TOOL_LIFETIME_LABELS = {
  [ToolLIFETIME.UNIT_COUNT]: 'UNIT_COUNT',
  [ToolLIFETIME.UNIT_HOUR]: 'UNIT_HOUR',
} as const

